const MediaQueryKeys = {
  global: ["media"] as const,
};

export { MediaQueryKeys };
